/* eslint-disable react/prop-types */
import { Typography } from '@mui/material';
import { postApiCall } from 'api/apiService';
import moment from 'moment';
import { counterAlignColumProp } from '../CountDownTimer/CountDownTimer.style';
import { UseCountdown } from '../CountDownTimer/UseCountdown';
const dataitem = 1;
function ExpiredNotice(props) {
  const { isUnPublished } = props;

  return (
    <div>
      {/* <Typography
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          padding: "20px 0px",
        }}
      >
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>D</Typography>
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>H</Typography>
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>M</Typography>
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>s</Typography>
        </Typography>
      </Typography> */}
    </div>
  );
}

function ShowCounter(
  { days, hours, minutes, seconds, propertyId, cardapi },
  props
) {
  const { isUnPublished } = props;
  let dayslen = String(days).length;
  let hourslen = String(hours).length;
  let minuteslen = String(minutes).length;
  let secondslen = String(seconds).length;

  return (
    <div>
      <Typography
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          whiteSpace: 'nowrap',
          gap: '5px',
          // padding: "10px 30px",
        }}
      >
        {/* {dataitem.length==2 ? (<Typography>fe</Typography>):(<Typography>0</Typography>)} */}
        {/* {days.length==1 && 
              <Typography>fe</Typography>
              }  */}
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography
              sx={{ fontWeight: 700, fontFamily: 'poppins', fontSize: '16px' }}
            >
              {String(days).includes('-') || isNaN(days) ? (
                '00:'
              ) : (
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'poppins',
                    fontSize: '16px',
                  }}
                >
                  {dayslen == 1 ? '0' : null}
                  {dayslen == 0 ? '00' : null}
                  {days}:
                </Typography>
              )}
            </Typography>
          ) : null}
          {/* <Typography sx={liveDTag}>D</Typography> */}
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography
              sx={{ fontWeight: 700, fontFamily: 'poppins', fontSize: '16px' }}
            >
              {String(hours).includes('-') || isNaN(hours) ? (
                '00:'
              ) : (
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'poppins',
                    fontSize: '16px',
                  }}
                >
                  {hourslen == 1 ? '0' : null}
                  {hourslen == 0 ? '00' : null}
                  {hours} :
                </Typography>
              )}
            </Typography>
          ) : null}
          {/* <Typography sx={liveDTag}>H</Typography> */}
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography
              sx={{ fontWeight: 700, fontFamily: 'poppins', fontSize: '16px' }}
            >
              {String(minutes).includes('-') || isNaN(minutes) ? (
                '00:'
              ) : (
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'poppins',
                    fontSize: '16px',
                  }}
                >
                  {minuteslen == 1 ? '0' : null}
                  {minuteslen == 0 ? '00' : null}
                  {minutes} :
                </Typography>
              )}
            </Typography>
          ) : null}
          {/* <Typography sx={liveDTag}>M</Typography> */}
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography
              sx={{ fontWeight: 700, fontFamily: 'poppins', fontSize: '16px' }}
            >
              {String(seconds).includes('-') || isNaN(seconds) ? (
                '00'
              ) : (
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'poppins',
                    fontSize: '16px',
                  }}
                >
                  {secondslen == 1 ? '0' : null}
                  {secondslen == 0 ? '00' : null}
                  {seconds}
                </Typography>
              )}
            </Typography>
          ) : null}
          {/* <Typography sx={liveDTag}>S</Typography> */}
        </Typography>
      </Typography>
    </div>
  );
}

function QuickSwitchTimer(
  { targetDate, isRunning = true, propertyId, cardapi, paused, pausestatus },
  props
) {
  const { isUnPublished } = props;
  const [days, hours, minutes, seconds] = UseCountdown(
    targetDate,
    true,
    isUnPublished
  );

  if (pausestatus) {
    const totalSeconds = Math.floor(paused / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    const remainingSeconds = totalSeconds % 60;
    const remainingMinutes = totalMinutes % 60;
    const remainingHours = totalHours % 24;
    const remainingDays = totalDays;
    const duration = moment.duration(paused, 'milliseconds');

    var pauseddays = remainingDays;
    var pausedhours = remainingHours;
    var pausedminutes = remainingMinutes;
    var pausedseconds = remainingSeconds;
  }

  if (isUnPublished) {
    return <ExpiredNotice />;
  }
  return (
    <ShowCounter
      days={pausestatus ? pauseddays : days}
      hours={pausestatus ? pausedhours : hours}
      minutes={pausestatus ? pausedminutes : minutes}
      seconds={pausestatus ? pausedseconds : seconds}
      propertyId={propertyId}
      isUnPublished={isUnPublished}
      cardapi={cardapi}
    />
  );
}

export default QuickSwitchTimer;
